import { makeStyles } from 'tss-react/mui'
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined'
import CloseIcon from '@mui/icons-material/Close'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import _colors from 'styles/global/_colors'
import genericStyles from 'styles/material-styles/genericStyles.js'
import { ThemeType } from 'ts/types/theme.types'
import { SuccessProps } from '../../../ts/interfaces/successProps.interface'

const useStyles = makeStyles()((theme: ThemeType) => ({
  success: {
    ...genericStyles.alertContainer,
    background: `linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), ${_colors.green}`,
    color: `${_colors.green}`,
    border: `1px solid ${_colors.green}`,
  },
  icon: {
    marginRight: '15px',
    color: `${_colors.green}`,
  },
  close: {
    marginLeft: '15px',
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  okButton: {
    textDecoration: 'none',
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },
}))

const Success = ({ description, onOk, onClose, okButtonLabel }: SuccessProps) => {
  const { classes } = useStyles()
  return (
    <div className={classes.success}>
      <CheckCircleOutlinedIcon className={classes.icon} />

      <div>{description}</div>
      {onOk && (
        <Button onClick={onOk} color="inherit" size="small" className={classes.okButton}>
          {okButtonLabel ?? 'OK'}
        </Button>
      )}
      {onClose && (
        <IconButton
          key="close"
          aria-label="Close"
          color="inherit"
          className={classes.close}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      )}
    </div>
  )
}

export default Success
